<ion-content class="ion-no-padding">
  <form [formGroup]="invoiceForm">
    <div class="lead-form model-container">
      <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white" *ngIf="!convertingQuote">
        <ion-toolbar class="header-first-toolbar">
          <ion-title class="text-start ion-no-padding title-blue">
            <span *ngIf="!editInvoiceId">Create New</span><span *ngIf="editInvoiceId">Edit</span> Invoice <span *ngIf="leadDetails"> For {{leadDetails.firstName}} {{leadDetails.lastName}}</span>
            <input [appMaxLength]="30" formControlName="internalInvoiceId" placeholder="Custom Invoice ID" class="ms-2 custom-invoice-id-input">
          </ion-title>
          <ion-buttons slot="end" class="ion-no-margin">
            <ion-button class="filled-blue-btn" type="submit" (click)="onSubmit(false)">Save</ion-button>
            <ion-button class="unfilled-gray-btn" (click)="closeModal()">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <div class="model-content">
        <div class="dashed-line"></div>
        <div class="form-container">
          <div class="invoice-form-container">
            <div>
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Invoice To</ion-title>
            </div>
            <div class="ion-padding-horizontal">
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Lead*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('clientId')?.invalid && invoiceForm.get('clientId')?.touched, 'empty-field': isFieldEmptyInForm('clientId') }">
                      <app-relatedto-data-input [selectedType]="'Lead'" [searchOnlyLeads]="true" (personData)="readClientDataOnSelect($event)" formControlName="clientId"></app-relatedto-data-input>
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Phone Number*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('clientPhoneNumber')?.invalid && invoiceForm.get('clientPhoneNumber')?.touched, 'empty-field': isFieldEmptyInForm('clientPhoneNumber') }">
                      <app-phone-country-input formControlName="clientPhoneNumber"></app-phone-country-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">First Name*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('clientFirstName')?.invalid && invoiceForm.get('clientFirstName')?.touched, 'empty-field': isFieldEmptyInForm('clientFirstName') }">
                      <input type="text" class="input input-text" formControlName="clientFirstName" placeholder="Client's first name" [appMaxLength]="50">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Last Name*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('clientLastName')?.invalid && invoiceForm.get('clientLastName')?.touched, 'empty-field': isFieldEmptyInForm('clientLastName') }">
                      <input type="text" class="input input-text" formControlName="clientLastName" placeholder="Client's last name" [appMaxLength]="50">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Email ID*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('clientEmail')?.invalid && invoiceForm.get('clientEmail')?.touched, 'empty-field': isFieldEmptyInForm('clientEmail') }">
                      <input type="text" class="input input-text" formControlName="clientEmail" placeholder="Email address" [appMaxLength]="64">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Address*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('clientAddress')?.invalid && invoiceForm.get('clientAddress')?.touched, 'empty-field': isFieldEmptyInForm('clientAddress') }">
                      <input type="text" class="input input-text" formControlName="clientAddress" placeholder="Client's address" [appMaxLength]="60">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">HSN Code</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('hsnCode')?.invalid && invoiceForm.get('hsnCode')?.touched, 'empty-field': isFieldEmptyInForm('hsnCode') }">
                      <input type="text" class="input input-text" formControlName="hsnCode" placeholder="Enter HSN Code" [appMaxLength]="8">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">GSTIN of Customer</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('gstNumberOfClinet')?.invalid && invoiceForm.get('gstNumberOfClinet')?.touched, 'empty-field': isFieldEmptyInForm('gstNumberOfClinet') }">
                      <input type="text" class="input input-text" formControlName="gstNumberOfClinet" placeholder="GSTIN of Customer" [appMaxLength]="15">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Place Of Supply*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('placeOfSupply')?.invalid && invoiceForm.get('placeOfSupply')?.touched, 'empty-field': isFieldEmptyInForm('placeOfSupply') }">
                      <!-- <input type="text" class="input input-text" formControlName="placeOfSupply" placeholder="Place of supply"> -->
                      <app-locations-autocomplete formControlName="placeOfSupply" [placeHolder]="'Place of supply'"></app-locations-autocomplete>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dashed-line mt-2"></div>
            <div>
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Invoice From</ion-title>
            </div>
            <div class="ion-padding-horizontal">
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Organization Name*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('ownershipName')?.invalid && invoiceForm.get('ownershipName')?.touched, 'empty-field': isFieldEmptyInForm('ownershipName') }">
                      <input type="text" class="input input-text" formControlName="ownershipName" [appMaxLength]="50" placeholder="Enter Organization's Name">
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Phone Number*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('ownershipPhoneNumber')?.invalid && invoiceForm.get('ownershipPhoneNumber')?.touched, 'empty-field': isFieldEmptyInForm('ownershipPhoneNumber') }">
                      <app-phone-country-input formControlName="ownershipPhoneNumber"></app-phone-country-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">GSTIN*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('ownershipGSTIN')?.invalid && invoiceForm.get('ownershipGSTIN')?.touched, 'empty-field': isFieldEmptyInForm('ownershipGSTIN') }">
                      <input type="text" class="input input-text" formControlName="ownershipGSTIN" [appMaxLength]="15" placeholder="Enter GST number">
                    </div>
                  </div>
                </div>

                <div class="col-6">
                  <div class="input-container">
                    <label for="" class="label">Office Email*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('ownershipOfficeEmail')?.invalid && invoiceForm.get('ownershipOfficeEmail')?.touched, 'empty-field': isFieldEmptyInForm('ownershipOfficeEmail') }">
                      <input type="text" class="input input-text" formControlName="ownershipOfficeEmail" [appMaxLength]="64" placeholder="Enter Office email">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dashed-line mt-2"></div>
            <div>
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Your Payment Details</ion-title>
            </div>
            <div class="ion-padding-horizontal">
              <div class="row">
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Beneficiary Name*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('beneficiaryName')?.invalid && invoiceForm.get('beneficiaryName')?.touched, 'empty-field': isFieldEmptyInForm('beneficiaryName') }">
                      <input type="text" class="input input-text" formControlName="beneficiaryName" [appMaxLength]="50" placeholder="Enter Account Holder's Name">
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Account Number*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('accountNumber')?.invalid && invoiceForm.get('accountNumber')?.touched, 'empty-field': isFieldEmptyInForm('accountNumber') }">
                      <input type="text" class="input input-text" formControlName="accountNumber" [appMaxLength]="18" placeholder="Enter Account Number">
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <div class="input-container">
                    <label for="" class="label">Bank Name*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('bankName')?.invalid && invoiceForm.get('bankName')?.touched, 'empty-field': isFieldEmptyInForm('bankName') }">
                      <input type="text" class="input input-text" formControlName="bankName" [appMaxLength]="100" placeholder="Enter Bank Name">
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <div class="input-container">
                    <label for="" class="label">IFSC Code*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('ifscCode')?.invalid && invoiceForm.get('ifscCode')?.touched, 'empty-field': isFieldEmptyInForm('ifscCode') }">
                      <input type="text" class="input input-text" formControlName="ifscCode" [appMaxLength]="11" placeholder="Enter IFSC Code">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Invoice Date*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('invoiceDate')?.invalid && invoiceForm.get('invoiceDate')?.touched, 'empty-field': isFieldEmptyInForm('invoiceDate') }">
                      <app-date-picker formControlName="invoiceDate" [maxDate]="todayDate"></app-date-picker>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Due Date*</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('dueDate')?.invalid && invoiceForm.get('dueDate')?.touched, 'empty-field': isFieldEmptyInForm('dueDate') }">
                      <app-date-picker formControlName="dueDate" [minDate]="convertToDate(invoiceForm.get('invoiceDate')?.value)"></app-date-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dashed-line mt-2"></div>
            <div class="mb-2">
              <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Invoice Items</ion-title>
            </div>
            <div class="ion-padding-horizontal">
              <div *ngIf="invoiceItems.invalid && invoiceItems.touched" class="text-danger" style="font-size: 12px;">
                Please fill out all required fields in the invoice items.
              </div>
              <table class="table table-bordered invoice-items-table">
                <thead>
                  <tr>
                    <th class="sm-column">S.no</th>
                    <th>Product*</th>
                    <th>Price*</th>
                    <th class="sm-column">People*</th>
                    <th>Total*</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody formArrayName="invoiceItems">
                  <tr *ngFor="let item of invoiceItems.controls; let i = index" [formGroupName]="i">
                    <td class="p-1">{{ i + 1 }}</td>
                    <td [ngClass]="{'empty-field':isInvoiceItemsCellEmpty(i, 'product')}">
                      <input formControlName="product" class="table-input" [appMaxLength]="50">
                    </td>
                    <td [ngClass]="{'empty-field':isInvoiceItemsCellEmpty(i, 'price')}">
                      <input appNumbersOnly formControlName="price"  class="table-input" [appMaxLength]="9">
                    </td>
                    <td [ngClass]="{'empty-field':isInvoiceItemsCellEmpty(i, 'quantity')}">
                      <input appNumbersOnly formControlName="quantity" class="table-input" [appMaxLength]="3">
                    </td>
                    <td>
                      <input type="text" readonly formControlName="total" class="table-input">
                      <!-- {{ item.get('total')?.value }} -->

                    </td>
                    <td>
                      <div class="table-actions">
                        <ion-button (click)="removeItem(i)" [disabled]="invoiceItems.controls.length === 1" fill="clear" color="danger" class="action-btn"><ion-icon name="trash-outline"></ion-icon></ion-button>
                      </div>
                      
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-end table-actions">
                <ion-button (click)="addItem()" fill="clear" class="action-btn blue"><ion-icon name="add-outline"></ion-icon> Invoice Item</ion-button>
              </div>
            </div>

            <div class="ion-padding-horizontal">
              <div class="row">
                <div class="col-4">
                  <div class="input-container">
                    <label class="label"><input type="checkbox" name="" id="" formControlName="isTcsApplicable"> Add TCS on total amount</label>
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-container">
                    <label class="label"><input type="checkbox" name="" id="" formControlName="isGstOnTotalAmount"> Calculate GST on total amount</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="ion-padding-horizontal">
              <div class="row">
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Invoice Amount*</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('totalInvoiceItemsAmount')}">
                      <app-select-text-input formControlName="totalInvoiceItemsAmount" [prefix]="'₹'" [readonly]="true"></app-select-text-input>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Service Amount</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('serviceAmount')}">
                      <app-select-text-input [prefix]="'₹'" formControlName="serviceAmount"></app-select-text-input>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Discounted Amount <span class="warning-message" *ngIf="invoiceForm.get('discountedAmount')?.hasError('requestedAmountExceedsBalance') && invoiceForm.get('discountedAmount')?.touched">Exceeded Invoice Amount</span></label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('discountedAmount')?.invalid && invoiceForm.get('discountedAmount')?.touched, 'empty-field': isFieldEmptyInForm('discountedAmount') }">
                      <app-select-text-input formControlName="discountedAmount" [prefix]="'₹'"></app-select-text-input>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">Amount (After discount)</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('totalAmountAfterDiscount')?.invalid && invoiceForm.get('totalAmountAfterDiscount')?.touched, 'empty-field': isFieldEmptyInForm('totalAmountAfterDiscount') }">
                      <app-select-text-input formControlName="totalAmountAfterDiscount" [prefix]="'₹'" [readonly]="true"></app-select-text-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Invoice amount details with gst -->
            <div class="ion-padding-horizontal">
              <!-- IGST section -->
              <div>
                <div class="row">
                  <div class="col-3">
                    <div class="d-flex input-container">
                      <div class="me-3"><input formControlName="selectedGstType" value="combinedGst" class="me-1" type="radio"> <label class="label">IGST</label></div>
                      <div class="me-3"><input formControlName="selectedGstType" value="seperateGst" class="me-1" type="radio"> <label class="label">CGST & SGST</label></div>
                    </div>
                  </div>
                </div>
              
                
                <div class="row"> 
                  <!-- Make this div visible if first radio btn is selected -->
                  <ng-container *ngIf="invoiceForm.get('selectedGstType')?.value === 'combinedGst'">
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">IGST (%)</label>
                        <div [ngClass]="{ 'invalid-input': invoiceForm.get('igstvalue')?.invalid && invoiceForm.get('igstvalue')?.touched, 'empty-field': isFieldEmptyInForm('igstvalue') }">
                          <app-gst-number-input formControlName="igstvalue"></app-gst-number-input>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Make this div visible if second radio btn is selected -->
                  <ng-container *ngIf="invoiceForm.get('selectedGstType')?.value === 'seperateGst'">
                    <div class="col-2">
                      <div class="input-container">
                        <label for="" class="label">CGST (%)</label>
                        <div [ngClass]="{ 'invalid-input': invoiceForm.get('cgstValue')?.invalid && invoiceForm.get('cgstValue')?.touched, 'empty-field': isFieldEmptyInForm('cgstValue') }">
                          <app-gst-number-input formControlName="cgstValue"></app-gst-number-input>
                        </div>
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="input-container">
                        <label for="" class="label">SGST (%)</label>
                        <div [ngClass]="{ 'invalid-input': invoiceForm.get('sgstValue')?.invalid && invoiceForm.get('sgstValue')?.touched, 'empty-field': isFieldEmptyInForm('sgstValue') }">
                          <app-gst-number-input formControlName="sgstValue"></app-gst-number-input>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="invoiceForm.get('isTcsApplicable')?.value">
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">TCS (%)</label>
                        <div [ngClass]="{ 'invalid-input': invoiceForm.get('tcsValue')?.invalid && invoiceForm.get('tcsValue')?.touched, 'empty-field': isFieldEmptyInForm('tcsValue') }">
                          <app-gst-number-input formControlName="tcsValue"></app-gst-number-input>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

                
              </div>

              <div class="row">
                <div class="col-3">
                  <div class="input-container">
                    <label for="" class="label">GST Amount</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('gstAmount')}">
                      <app-select-text-input formControlName="gstAmount" [prefix]="'₹'" [readonly]="true"></app-select-text-input>
                    </div>
                  </div>
                </div>

                <div class="col-3" *ngIf="invoiceForm.get('isTcsApplicable')?.value">
                  <div class="input-container">
                    <label for="" class="label">TCS Amount</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('tcsAmount')}">
                      <app-select-text-input formControlName="tcsAmount" [prefix]="'₹'" [readonly]="true"></app-select-text-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Net Payable</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('netPayable')}">
                      <app-select-text-input formControlName="netPayable" [prefix]="'₹'" [readonly]="true"></app-select-text-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="input-container">
                    <label for="" class="label">Total Amount In Words</label>
                    <div>
                      <input type="text" formControlName="balanceAmountInWords" class="input" readonly>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="amountReceviedAgainstLead">
                <div class="col-12">
                  <div class="input-container">
                    <p class="mb-0" style="font-size: 14px; color: var(--danger-color);">Please note that an advance payment of ₹{{amountReceviedAgainstLead}} has already been received for this lead. All previous payment records will be linked to this invoice upon submission.</p>
                  </div>
                </div>
              </div>

              <div class="row my-2">
                <div class="col-6">
                  <div class="input-container">
                    <div class="d-flex align-items-center">
                      <input type="checkbox" id="advanceRecived" class="me-2" [checked]="advanceRecieved" (change)="toggleAdvanceRecieved($event)">
                      <label for="advanceRecived" class="label">Advance Recieved</label>
                    </div>
                    
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="advanceRecieved">
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Payment Method *</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('paymentMethod')?.invalid && invoiceForm.get('paymentMethod')?.touched, 'empty-field': isFieldEmptyInForm('paymentMethod') }">
                      <input formControlName="paymentMethod" type="text" class="input" placeholder="Cash/UPI/NEFT" [appMaxLength]="30">
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Payment Reference no.</label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('paymentReferenceNumber')?.invalid && invoiceForm.get('paymentReferenceNumber')?.touched, 'empty-field': isFieldEmptyInForm('paymentReferenceNumber') }">
                      <input formControlName="paymentReferenceNumber" type="text" class="input" placeholder="Enter payment refernce no." [appMaxLength]="35">
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="input-container">
                    <label for="" class="label">Advance Recieved * <span class="warning-message" *ngIf="invoiceForm.get('amountPaid')?.hasError('requestedAmountExceedsBalance') && invoiceForm.get('amountPaid')?.touched">Exceeded Total Amount</span></label>
                    <div [ngClass]="{ 'invalid-input': invoiceForm.get('amountPaid')?.invalid && invoiceForm.get('amountPaid')?.touched, 'empty-field': isFieldEmptyInForm('amountPaid') }">
                      <app-select-text-input formControlName="amountPaid" [prefix]="'₹'"></app-select-text-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="dashed-line mt-2 mb-1"></div>

              <div class="row">
                <div class="col-12">
                  <div class="input-container">
                    <label for="" class="label">Cancellation Policy</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('cancellationPolicy')}">
                      <textarea formControlName="cancellationPolicy" class="input input-textarea" placeholder="Enter Cancellation Policy Here"></textarea>
                    </div>
                  </div>
                </div>
                
                <div class="col-12">
                  <div class="input-container">
                    <label for="" class="label">Late payment Terms</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('latePaymentTerms')}">
                      <textarea formControlName="latePaymentTerms" class="input input-textarea"  placeholder="Enter Late Payment Terms Here"></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="input-container">
                    <label for="" class="label">Terms & Conditions</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('termsAndConditions')}">
                      <textarea formControlName="termsAndConditions" class="input input-textarea" placeholder="Enter Terms and Conditions Here"></textarea>
                    </div>
                  </div>
                </div>
                
                <div class="col-12">
                  <div class="input-container">
                    <label for="" class="label">Notes</label>
                    <div [ngClass]="{'empty-field': isFieldEmptyInForm('notes')}">
                      <textarea formControlName="notes" class="input input-textarea" placeholder="Enter Invoice Notes Here"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ion-content>
